export enum DYNATRACE_ACTIONS {
  LOGIN = 'login',
  SIGN_OUT = 'sign_out',
  PROFILE_MENU = 'profile_menu',
  PERSONAL_DETAILS = 'personal_details',
  CHANGE_PASSWORD = 'change_password',
  SWITCH_COMPANY = 'switch_company',
  SWITCH_SITE = 'switch_site',
  SWITCH_DATE_VIA_CALENDAR = 'switch_date_via_calendar',
  SWITCH_DATE_FORWARD = 'switch_date_forward',
  SWITCH_DATE_BACKWARD = 'switch_date_backward',
  COMPANY_SEARCH = 'company_search',
  VIEW_ALL_ALL_MARKETS = 'view_all_markets',
  VIEW_WHOLESALE_MARKETS = 'view_wholesale_markets',
  VIEW_ANCILLARY_MARKETS = 'view_ancillary_markets',
  VIEW_BALANCING_MECHANISM = 'view_balancing_mechanism',
  VIEW_REVENUE_BREAKDOWN_EXPANDED = 'view_revenue_breakdown_expanded',
  TOOLTIP_REVENUE_BREAKDOWN = 'tooltip_revenue_breakdown',
  TOOLTIP_TOTAL_REVENUE = 'tooltip_total_revenue',
  TOOLTIP_TOTAL_REVENUE_PER_INSTALLED_MW = 'tooltip_revenue_per_installed_mw',
  TOOLTIP_NEGATIVE_REVENUE = 'tooltip_negative_revenue',
  TOOLTIP_VOLUME_OVERVIEW = 'tooltip_volume_overview',
  DOWNLOAD_TRADE_DATA = 'download_trade_data',
}
